import {
  formatError,
  getProfile,
  login,
  runLogoutTimer,
  saveTokenInLocalStorage,
  signUp,
} from '../../services/AuthService';
import { SET_USER_PROFILE } from './actionTypes';

export const SIGNUP_CONFIRMED_ACTION = '[signup action] confirmed signup';
export const SIGNUP_FAILED_ACTION = '[signup action] failed signup';
export const LOGIN_CONFIRMED_ACTION = '[login action] confirmed login';
export const LOGIN_FAILED_ACTION = '[login action] failed login';
export const LOADING_TOGGLE_ACTION = '[Loading action] toggle loading';
export const LOGOUT_ACTION = '[Logout action] logout action';
export const NAVTOGGLE = 'NAVTOGGLE';

export const signupAction = (email, password, navigate) => async (dispatch) => {
  try {
    const response = await signUp(email, password);
    await saveTokenInLocalStorage(response.data);
    //runLogoutTimer(dispatch, response.data.expireIn * 1000);
    dispatch(confirmedSignupAction(response.data));
    navigate('/dashboard');
  } catch (error) {
    dispatch(signupFailedAction(formatError(error.response.data)));
  }
};

export const Logout = (navigate) => {
  localStorage.removeItem('user');
  localStorage.clear();
  navigate('/login', { replace: true });
  window.location.reload();

  return { type: LOGOUT_ACTION };
};

export const loginAction =
  (sso = true, email, password, userInfo, navigate, azureSSO = false) =>
  async (dispatch) => {
    try {
      if (azureSSO === false) {
        const response = await login(sso, email, password, userInfo);
        await saveTokenInLocalStorage(response.data);
        dispatch(loginConfirmedAction(response.data));
      } else {
        await saveTokenInLocalStorage(userInfo);
        dispatch(loginConfirmedAction(userInfo));
      }
      const profile = await getProfile();
      if (profile && profile.data && profile.data.allowedModules) {
        dispatch(setUserProfileAction(profile.data));
        if (profile.data.mustChangePassword) {
          navigate('/change-password');
          return;
        }
        const hasDashboardMenu = profile.data.allowedModules.some(
          (module) => module.value.trim() === 'dashboard' && module.operations.includes('menu')
        );
        // Ensure Admin always goes to dashboard, or if dashboard menu is present
        if (
          hasDashboardMenu === true ||
          (profile.data.role && profile.data.role.toLowerCase() === 'admin')
        ) {
          navigate('/dashboard');
        } else {
          navigate('/forms');
        }
      }
    } catch (error) {
      console.error('Login Error:', error);
      dispatch(loginFailedAction(error));
      // navigate('/login');
      throw error;
    }
  };

// Action Creators
export const setUserProfileAction = (profile) => ({
  type: SET_USER_PROFILE,
  payload: profile,
});

export const loginFailedAction = (data) => ({
  type: LOGIN_FAILED_ACTION,
  payload: data,
});

export const loginConfirmedAction = (data) => ({
  type: LOGIN_CONFIRMED_ACTION,
  payload: data,
});

export const confirmedSignupAction = (payload) => ({
  type: SIGNUP_CONFIRMED_ACTION,
  payload,
});

export const signupFailedAction = (message) => ({
  type: SIGNUP_FAILED_ACTION,
  payload: message,
});

export const loadingToggleAction = (status) => ({
  type: LOADING_TOGGLE_ACTION,
  payload: status,
});

export const navtoggle = () => ({ type: NAVTOGGLE });
